import { createSelector } from '@ngrx/store';

import { onlineOrderState } from '../root';

export const hasRecalculateFailed = createSelector(onlineOrderState, (onlineOrder) => onlineOrder.recalculateRequest.hasFailed);
